export const CONFIRM_ORDER_GET_POST = "order";
export const VERIFICATION_CODE_GET_POST = "otp-code";
export const LANDING_PAGE_ORDER_GET_POST_CONFIRM = "/landpage-order";